"use client";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { AnimalDataTable } from "@/features/Government Observer/animal-data-table";
import DashboardHeader from "@/features/ui/DashboardHeader.tsx";
import { StatisticsCards } from "@/features/Government Observer/statistics-cards.tsx";

import logo from "/public/logo.png";

export function AnimalDashboard({ data }: { data: any }) {
  return (
    <div className="space-y-6 w-full sm:flex sm:flex-col justify-center z-10">
      <div
        id={"dashboardLogo"}
        className={
          "w-full mx-auto lg:flex-row lg:items-center lg:justify-center flex flex-col-reverse items-center sm:justify-center lg:flex z-20 md:flex md:flex-row md:items-center md:justify-center"
        }
      >
        {/* <DualLogoShowcase firstLogoSrc={logo} size="md" /> */}
        <img alt="Logo" className="h-16 z-20 " src={logo} />
        <DashboardHeader />
      </div>
      <div id="statisticsCards">
        <StatisticsCards animals={data ?? []} />
      </div>
      <Card>
        <CardHeader className={"text-[#008c8fff]"}>
          <CardTitle>Animals</CardTitle>
          <CardDescription className={"text-[#015354ff]"}>
            A list of all animals in the system. Click on an animal to view
            detailed information.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div id="dashboardHeader">
            <AnimalDataTable animals={data ?? []} />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
